import { withAsync } from '@/components/Async'
import type { RouteConfig } from 'react-router-config'

const routes: RouteConfig[] = [
  {
    name: 'dashboard',
    path: '/dashboard',
    component: withAsync(() => import(/* webpackChunkName: "Dashboard" */ '@/containers/Dashboard')),
    exact: true,
    main: true,
    permissionCode: 'dashboard',
  },
]

export default routes
